import type { HomeFeedItem } from '@cade/shared-types';

function formatTimeAgo(timestamp: string): string {
  const now = Date.now();
  const then = new Date(timestamp).getTime();
  const diffMs = now - then;
  const diffMin = Math.floor(diffMs / 60000);
  if (diffMin < 1) return 'just now';
  if (diffMin < 60) return `${diffMin}m ago`;
  const diffHr = Math.floor(diffMin / 60);
  if (diffHr < 24) return `${diffHr}h ago`;
  const diffDays = Math.floor(diffHr / 24);
  return `${diffDays}d ago`;
}

interface HomeFeedCardProps {
  item: HomeFeedItem;
  onNavigate: (resourceId: string, resourceType: string) => void;
}

export function HomeFeedCard({ item, onNavigate }: HomeFeedCardProps) {
  const showStripe = item.section === 'attention' && item.severity;

  return (
    <button
      className="home-card"
      onClick={() => onNavigate(item.resourceId, item.resourceType)}
      type="button"
    >
      {showStripe && (
        <div
          className="home-card-severity"
          style={{ backgroundColor: `var(--sev-${item.severity})` }}
        />
      )}
      <div className="home-card-body">
        <div className="home-card-title">{item.title}</div>
        <div className="home-card-summary">{item.summary}</div>
        <div className="home-card-meta">
          <span className="home-card-source">{item.source}</span>
          <span className="home-card-reason">{item.reason}</span>
          <span className="home-card-time">{formatTimeAgo(item.timestamp)}</span>
        </div>
      </div>
    </button>
  );
}
